import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { AppHttpService } from '../AppServices/app.httpservices';
import { Router, ActivatedRoute } from '@angular/router';
import { Project } from '../Models/Project';

@Component({
  selector: 'app-adminprojects',
  templateUrl: './adminprojects.component.html',
  styleUrls: ['./adminprojects.component.css']
})
export class AdminprojectsComponent implements OnInit {

  group: FormGroup;
  filesList: FileList;
  isUploadSuccess = false;
  isUploadComplete = false;
  isUploading = false;
  projectId: number;
  selectedProject;
  SelectedProjectImage = '';
  SelectedProjectID = 0;
  newProject = true;
  missingFiles = false;
  descriptionMissing = false;
  titleMissing = false;

  constructor(private fb: FormBuilder, private httpClient: AppHttpService,
    private route: ActivatedRoute, private router: Router) { }

  Back() {
    this.router.navigate(["Admin/ProjectList"]);
  }
  ngOnInit() {
    this.group = this.fb.group({
      title: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required)
    });
    this.route.params.subscribe(params => {
      this.projectId = params['id'];
      if (this.projectId > 0) {
        const myParams = new HttpParams().append('ProjectId', this.projectId.toString());

        this.httpClient.get<Project>("api/Projects/GetProject", myParams).subscribe(data => {
          this.selectedProject = data;

          if (data) {
            this.group.get('title').setValue(data.title);
            this.group.get('description').setValue(data.description);
            this.SelectedProjectID = data.projectId;
            this.SelectedProjectImage = data.imageFile;
            this.newProject = false;
          }
        });

      }
      else {
        this.newProject = true;
      }
    });

  }

  UpdateFile(event) {
    this.filesList = event.target.files;
  }
  Save() {

    this.descriptionMissing = false;
    this.titleMissing = false;
    this.isUploading = true;
    let headers = new HttpHeaders();
    //this is the important step. You need to set content type as null
    headers.set('Content-Type', null);
    headers.set('Accept', "multipart/form-data");
    let params = new HttpParams();
    const formData: FormData = new FormData();

    if (this.newProject && !this.filesList) {
      this.missingFiles = true;
      this.isUploading = false;
      return;
    }

    if (this.newProject && this.filesList.length > 0) {
      for (let i = 0; i < this.filesList.length; i++) {
        formData.append('fileArray', this.filesList[i], this.filesList[i].name);
      }
    }

    if (!this.newProject && this.filesList && this.filesList.length > 0) {
      for (let i = 0; i < this.filesList.length; i++) {
        formData.append('fileArray', this.filesList[i], this.filesList[i].name);
      }
    }

    if (this.group.get('title').value.length > 0 && this.group.get('description').value.length > 0) {
      formData.append('title', this.group.get('title').value);
      formData.append('description', this.group.get('description').value);
      formData.append('id', this.SelectedProjectID.toString());
      this.httpClient.postFile('api/Projects/UploadProject', formData, params, headers).subscribe((data: boolean) => {
        this.isUploadSuccess = data;
        this.isUploadComplete = true;
        this.isUploading = false;
        this.router.navigate(['Admin/ProjectList/' + 1])
      }, error => {
        this.isUploadComplete = true;
        this.isUploadSuccess = false;
        this.isUploading = false;
      });

    } else {
      this.isUploading = false;
      if(this.group.get('title').value.length <= 0)
      {
        this.titleMissing = true;
      }
      if(this.group.get('description').value.length <= 0)
      {
        this.descriptionMissing = true;
      }
    }
  }
}


